import React, { useState, useRef, useEffect } from 'react';
import { Phone, ArrowLeft, X, Loader2 } from 'lucide-react';
import { useTranslation, Trans } from 'react-i18next';
// --- 恢復真實的驗證服務引用 ---
import { sendOtp, verifyOtp } from './services/authService';
import myLogoImg from './assets/logo-peaches.png';

const LoginPageStyles = () => (
  <style>{`
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes fadeOut {
      from { opacity: 1; }
      to { opacity: 0; }
    }

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes slideDown {
      from {
        opacity: 1;
        transform: translateY(0);
      }
      to {
        opacity: 0;
        transform: translateY(20px);
      }
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    .login-page {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: clamp(15px, 3vw, 20px);
      z-index: 1000;
      overflow-y: auto;
      animation: fadeIn 0.3s ease;
    }

    .login-page.closing {
      animation: fadeOut 0.3s ease;
    }

    .login-content {
      background: #fff;
      border-radius: 4px;
      padding: clamp(30px, 6vw, 50px);
      max-width: 450px;
      width: 100%;
      text-align: center;
      box-shadow: 0 4px 20px rgba(0,0,0,0.08);
      margin: auto;
      position: relative;
      animation: slideUp 0.3s ease;
    }

    .login-content.closing {
      animation: slideDown 0.3s ease;
    }

    .login-close-btn {
      position: absolute;
      top: clamp(15px, 3vw, 20px);
      right: clamp(15px, 3vw, 20px);
      width: clamp(32px, 7vw, 40px);
      height: clamp(32px, 7vw, 40px);
      border: none;
      background: #f5f5f5;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      color: #666;
      padding: 0;
      z-index: 10;
    }

    .login-close-btn:active {
      transform: scale(0.95);
      background: #e0e0e0;
    }

    .login-close-btn svg {
      width: clamp(18px, 4vw, 20px);
      height: clamp(18px, 4vw, 20px);
    }

    .login-logo {
      width: clamp(70px, 18vw, 90px);
      height: clamp(70px, 18vw, 90px);
      border-radius: 50%;
      object-fit: cover;
      margin: 0 auto clamp(20px, 4vw, 30px);
      display: block;
      box-shadow: 0 4px 16px rgba(0,0,0,0.08);
      border: 3px solid #f0f0f0;
    }

    .login-title {
      font-size: clamp(1.5rem, 4vw, 2rem);
      font-weight: 400;
      color: #111;
      margin-bottom: 10px;
      line-height: 1.2;
    }

    .login-subtitle {
      font-size: clamp(0.875rem, 2.5vw, 1rem);
      color: #666;
      margin-bottom: clamp(25px, 5vw, 35px);
      font-weight: 400;
      min-height: 1.2rem;
      line-height: 1.5;
    }

    .login-form {
      display: flex;
      flex-direction: column;
      gap: clamp(15px, 3vw, 20px);
      text-align: left;
    }

    .login-form-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .login-label {
      font-size: clamp(0.7rem, 2vw, 0.75rem);
      font-weight: 400;
      color: #111;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .login-input-wrapper {
      position: relative;
    }

    .login-input-icon {
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      color: #999;
      width: 18px;
      height: 18px;
      flex-shrink: 0;
      z-index: 2;
    }

    /* --- +1 前綴樣式 --- */
    .login-input-prefix {
      position: absolute;
      left: 45px;
      top: 50%;
      transform: translateY(-50%);
      color: #111;
      font-weight: 400;
      font-size: 16px;
      pointer-events: none;
      z-index: 2;
      display: flex;
      align-items: center;
      gap: 4px;
      user-select: none;
      -webkit-user-select: none;
    }

    .login-input-prefix::after {
      content: '';
      display: block;
      width: 1px;
      height: 14px;
      background: #e0e0e0;
      margin-left: 6px;
    }

    .login-input {
      padding: clamp(12px, 2.5vw, 14px) 16px clamp(12px, 2.5vw, 14px) clamp(45px, 10vw, 50px);
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      font-size: 16px;
      font-family: inherit;
      transition: all 0.3s ease;
      background: #fff;
      width: 100%;
      box-sizing: border-box;
    }

    .login-input.has-prefix {
      padding-left: 90px;
    }

    .login-input:focus {
      outline: none;
      border-color: #2F7D5E;
      box-shadow: 0 0 0 3px rgba(47, 125, 94, 0.15);
    }

    .login-input:disabled {
      background: #f5f5f5;
      cursor: not-allowed;
    }

    /* --- OTP 六格輸入框樣式 --- */
    .otp-container {
      display: flex;
      gap: clamp(5px, 1.5vw, 10px);
      justify-content: space-between;
      margin-top: 5px;
    }

    .otp-input {
      width: 100%;
      aspect-ratio: 1;
      height: auto;
      min-height: clamp(45px, 10vw, 55px);
      font-size: clamp(20px, 4vw, 24px);
      font-weight: 400;
      text-align: center;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      background: #fff;
      transition: all 0.2s;
      caret-color: #2F7D5E;
      padding: 0;
      font-family: inherit;
    }

    .otp-input:focus {
      border-color: #2F7D5E;
      outline: none;
      box-shadow: 0 4px 12px rgba(47,125,94,0.1);
      transform: translateY(-2px);
    }

    .otp-input:disabled {
      background: #f5f5f5;
      cursor: not-allowed;
    }

    .login-error {
      color: #ff6b6b;
      font-size: clamp(0.8rem, 2vw, 0.9rem);
      text-align: center;
      margin-bottom: 10px;
      padding: 10px;
      background: #fff5f5;
      border-radius: 4px;
    }

    .login-success {
      color: #51cf66;
      font-size: clamp(0.8rem, 2vw, 0.9rem);
      text-align: center;
      margin-bottom: 10px;
      padding: 10px;
      background: #f0fff4;
      border-radius: 4px;
    }

    .login-btn {
      padding: clamp(14px, 3vw, 16px) clamp(20px, 4vw, 30px);
      border: none;
      font-size: 16px;
      font-weight: 400;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      letter-spacing: 0.3px;
      border-radius: 4px;
      font-family: inherit;
    }

    .login-btn:active:not(:disabled) {
      transform: scale(0.98);
    }

    .login-btn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .login-btn-primary {
      background: #2F7D5E;
      color: #fff;
      box-shadow: 0 4px 12px rgba(47,125,94,0.2);
      flex: 1;
    }

    .login-btn-secondary {
      background: #fff;
      color: #2F7D5E;
      border: 1px solid #e0e0e0;
      flex: 1;
    }

    .login-btn-full {
      width: 100%;
      margin-top: 10px;
      padding: clamp(16px, 3.5vw, 18px);
    }

    .login-button-group {
      display: flex;
      gap: clamp(10px, 2vw, 15px);
      margin-top: 10px;
    }

    .spinner {
      animation: spin 1s linear infinite;
    }

    .pin-hint {
      font-size: clamp(0.8rem, 2vw, 0.9rem);
      color: #666;
      margin-top: 12px;
      text-align: center;
      animation: fadeIn 0.5s ease;
    }

    .pin-resend-btn {
      background: none;
      border: none;
      color: #2F7D5E;
      text-decoration: underline;
      cursor: pointer;
      font-size: inherit;
      padding: 0 5px;
      font-family: inherit;
      transition: opacity 0.3s;
    }

    .pin-resend-btn:disabled {
      cursor: default;
      text-decoration: none;
      color: #999;
    }

    @media (max-width: 375px) {
      .login-content {
        padding: 25px 20px;
      }

      .login-close-btn {
        top: 12px;
        right: 12px;
        width: 30px;
        height: 30px;
      }

      .login-input-icon {
        left: 12px;
        width: 16px;
        height: 16px;
      }

      .login-input-prefix {
        left: 36px;
      }

      .login-input.has-prefix {
        padding-left: 80px;
      }

      .otp-input {
        border-radius: 4px;
      }
    }

    @media (max-height: 600px) and (orientation: landscape) {
      .login-page {
        padding: 10px;
        align-items: flex-start;
      }

      .login-content {
        padding: 20px;
        margin: 10px auto;
      }

      .login-close-btn {
        top: 10px;
        right: 10px;
        width: 28px;
        height: 28px;
      }

      .login-icon-wrapper {
        width: 50px;
        height: 50px;
        margin-bottom: 15px;
      }

      .login-icon-wrapper svg {
        width: 24px;
        height: 24px;
      }

      .login-title {
        font-size: 1.25rem;
        margin-bottom: 5px;
      }

      .login-subtitle {
        font-size: 0.85rem;
        margin-bottom: 15px;
      }

      .login-form {
        gap: 12px;
      }
    }

    @media (min-width: 769px) {
      .login-close-btn:hover {
        background: #e0e0e0;
        color: #111;
        transform: rotate(90deg);
      }

      .login-btn:hover:not(:disabled) {
        transform: translateY(-2px);
      }

      .login-btn-primary:hover:not(:disabled) {
        background: #245F48;
        box-shadow: 0 6px 20px rgba(47,125,94,0.25);
      }

      .login-btn-secondary:hover:not(:disabled) {
        border-color: #2F7D5E;
        background: #f8f8f8;
      }

      .login-input:hover {
        border-color: #c0c0c0;
      }

      .login-input,
      .login-btn {
        font-size: clamp(0.9rem, 2vw, 1rem);
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .login-page,
      .login-content {
        animation: none;
      }

      .login-btn,
      .login-input,
      .login-close-btn {
        transition: none;
      }

      .login-close-btn:hover {
        transform: none;
      }
    }

    @media (prefers-color-scheme: dark) {
      .login-page {
        background: rgba(0, 0, 0, 0.85);
      }

      .login-content {
        background: #1a1a1a;
        box-shadow: 0 10px 40px rgba(0,0,0,0.5);
      }

      .login-close-btn {
        background: #2a2a2a;
        color: #999;
      }

      .login-close-btn:active {
        background: #333;
      }

      .login-icon-wrapper {
        background: #2F7D5E;
        color: #fff;
      }

      .login-title {
        color: #ffffff;
      }

      .login-subtitle {
        color: #999;
      }

      .login-label {
        color: #e0e0e0;
      }

      .login-input {
        background: #2a2a2a;
        border-color: #404040;
        color: #ffffff;
      }

      .login-input-prefix {
        color: #ffffff;
      }

      .login-input-prefix::after {
        background: #404040;
      }

      .login-input:focus {
        border-color: #2F7D5E;
        box-shadow: 0 0 0 3px rgba(47, 125, 94, 0.2);
      }

      .login-error {
        background: rgba(255, 107, 107, 0.1);
        color: #ff8888;
      }

      .login-success {
        background: rgba(81, 207, 102, 0.1);
        color: #51cf66;
      }

      .login-btn-primary {
        background: #2F7D5E;
        color: #fff;
      }

      .login-btn-secondary {
        background: #2a2a2a;
        color: #ffffff;
        border-color: #404040;
      }

      .otp-input {
        background: #2a2a2a;
        border-color: #404040;
        color: #ffffff;
      }

      .otp-input:focus {
        border-color: #2F7D5E;
        box-shadow: 0 0 0 3px rgba(47, 125, 94, 0.2);
      }

      .pin-hint {
        color: #999;
      }

      .pin-resend-btn {
        color: #2F7D5E;
      }
    }
  `}</style>
);

const LoginPage = ({ onLogin, onClose }) => {
  const { t } = useTranslation('login');
  const [step, setStep] = useState('phone'); // 'phone' | 'verify'
  const [phoneNumber, setPhoneNumber] = useState('');

  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // 新增：倒數計時狀態
  const [countdown, setCountdown] = useState(0);

  const inputRefs = useRef([]);
  // 新增：表單引用，用於自動提交
  const formRef = useRef(null);

  const authCode = otp.join('');

  useEffect(() => {
    if (step === 'verify') {
      setTimeout(() => {
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
      }, 100);
    }
  }, [step]);

  // 新增：處理倒數計時器
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  // 手機號碼輸入，強制過濾非數字且限制長度
  const handlePhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, '');
    if (val.length <= 10) {
      setPhoneNumber(val);
    }
  };

  const getFullPhoneNumber = (rawNumber) => {
    return `+1${rawNumber}`;
  };

  // 第一步：發送驗證碼
  const handleSendCode = async (e) => {
    if (e) e.preventDefault();

    if (phoneNumber.length !== 10) {
      setError(t('error_phone_length'));
      return;
    }

    const fullNumber = getFullPhoneNumber(phoneNumber);

    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      const result = await sendOtp(fullNumber);

      if (result.success) {
        setStep('verify');
        setCountdown(60);
      } else {
        setError(result.errorKey ? t(result.errorKey) : t('error_send_failed'));
      }
    } catch (err) {
      setError(t('error_network'));
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpChange = (e, index) => {
    const val = e.target.value;
    if (isNaN(val)) return;

    const newOtp = [...otp];
    newOtp[index] = val.substring(val.length - 1);
    setOtp(newOtp);

    if (val && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  // 修改：貼上處理，支援自動提交
  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6).split('');

    if (pastedData.length === 0) return;

    const newOtp = [...otp];
    pastedData.forEach((val, i) => {
        if (i < 6) newOtp[i] = val;
    });
    setOtp(newOtp);

    if (pastedData.length === 6) {
       setTimeout(() => {
          if (formRef.current) {
             formRef.current.requestSubmit();
          }
       }, 100);
    } else {
      const focusIndex = Math.min(pastedData.length, 5);
      inputRefs.current[focusIndex].focus();
    }
  };

  // 第二步：驗證 PIN 碼
  const handleVerifyCode = async (e) => {
    e.preventDefault();

    const currentCode = otp.join('');

    if (currentCode.length !== 6) {
      setError(t('error_otp_length'));
      return;
    }

    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      const fullNumber = getFullPhoneNumber(phoneNumber);
      const result = await verifyOtp(fullNumber, currentCode);

      if (result.success) {
        setTimeout(() => {
          if (onLogin) {
            onLogin(fullNumber, result.user);
          }
        }, 800);
      } else {
        setError(result.errorKey ? t(result.errorKey) : t('error_otp_invalid'));
        setIsLoading(false);
      }
    } catch (err) {
      setError(t('error_generic'));
      setIsLoading(false);
    }
  };

  const handleResend = async () => {
     if (countdown > 0) return;
     handleSendCode();
  };

  const handleBack = () => {
    setStep('phone');
    setError('');
    setSuccess('');
    setOtp(['', '', '', '', '', '']);
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  return (
    <>
      <LoginPageStyles />
      <div className="login-page" onClick={handleBackdropClick}>
        <div className="login-content">
          <button
            className="login-close-btn"
            onClick={handleClose}
            aria-label={t('close_aria')}
            type="button"
            disabled={isLoading}
          >
            <X />
          </button>

          <img src={myLogoImg} alt="Logo" className="login-logo" />

          <h1 className="login-title">
            {step === 'phone' ? t('title_phone') : t('title_verify')}
          </h1>
          {step === 'phone' && (
            <p className="login-subtitle">{t('subtitle_phone')}</p>
          )}

          <form
            className="login-form"
            onSubmit={step === 'phone' ? handleSendCode : handleVerifyCode}
            ref={formRef}
          >
            {error && <div className="login-error">{error}</div>}
            {success && <div className="login-success">{success}</div>}

            {step === 'phone' ? (
              // --- 步驟一：輸入手機號碼 ---
              <div className="login-form-group">
                <label className="login-label">{t('label_phone')}</label>
                <div className="login-input-wrapper">
                  <Phone className="login-input-icon" />
                  <div className="login-input-prefix">+1</div>
                  <input
                    className="login-input has-prefix"
                    type="tel"
                    placeholder={t('placeholder_phone')}
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    disabled={isLoading}
                    maxLength={10}
                  />
                </div>
              </div>
            ) : (
              // --- 步驟二：輸入 PIN 碼 (6格) ---
              <div className="login-form-group">
                <label className="login-label">{t('label_otp')}</label>
                <div className="otp-container">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      className="otp-input"
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                      onPaste={handleOtpPaste}
                      disabled={isLoading}
                      autoComplete="off"
                    />
                  ))}
                </div>
                <div className="pin-hint">
                  {t('resend_hint')}
                  <button
                    type="button"
                    className="pin-resend-btn"
                    onClick={handleResend}
                    disabled={isLoading || countdown > 0}
                    style={{ opacity: countdown > 0 ? 0.6 : 1 }}
                  >
                    {countdown > 0 ? t('resend_countdown', { seconds: countdown }) : t('resend_btn')}
                  </button>
                </div>
              </div>
            )}

            {step === 'phone' ? (
              <button
                type="submit"
                className="login-btn login-btn-primary login-btn-full"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Loader2 size={18} className="spinner" />
                    {t('btn_sending')}
                  </>
                ) : (
                  t('btn_send')
                )}
              </button>
            ) : (
              <div className="login-button-group">
                <button
                  type="button"
                  onClick={handleBack}
                  className="login-btn login-btn-secondary"
                  disabled={isLoading}
                >
                  <ArrowLeft size={18} />
                  {t('btn_back')}
                </button>
                <button
                  type="submit"
                  className="login-btn login-btn-primary"
                  disabled={isLoading || authCode.length !== 6}
                >
                  {isLoading ? (
                    <Loader2 size={18} className="spinner" />
                  ) : (
                    t('btn_login')
                  )}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
